import React from "react";
import { useHistory } from "react-router";
import { Box, Grid } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
// import Typography from "@material-ui/core/Typography";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
// import Brightness4Icon from "@material-ui/icons/Brightness4";
// import BrightnessHighIcon from "@material-ui/icons/BrightnessHigh";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import MenuIcon from "@material-ui/icons/Menu";
import clsx from "clsx";
import { logOutAction } from "src/app-redux/auth/actions/authActions";
import { useAppDispatch } from "src/app-redux/hooks";
import NatJanWhiteLogo from "src/assets/images/tfg_favicon_white.svg";
import { DRAWER_WIDTH } from "./SideNav";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.modal + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },

    appBarShift: {
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      marginLeft: DRAWER_WIDTH,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    // title: {
    //   flexGrow: 1,
    //   textAlign: "center",
    // },
  })
);

type Props = { open: boolean; toggleDrawer: () => void };

export function Header(props: Props) {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const trigger = useScrollTrigger();
  // const openDrawer = useAppSelector(selectMobileDrawer);

  // const isDarkTheme = useTheme().palette.type === "dark";
  // const toggleTheme = () => {
  //   dispatch(themeTypeAction(isDarkTheme ? "light" : "dark"));
  // };

  return (
    // <Slide appear={false} direction="down" in={!trigger}>
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: props.open,
      })}
    >
      <Toolbar>
        <Grid justify="space-between" container>
          <Grid item>
            <Grid container direction="row" justify="flex-start" alignItems="center">
              <Box mt={1} mb={1} my={1}>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={props.toggleDrawer}
                  edge="start"
                  // className={clsx(classes.menuButton, {
                  //   [classes.hide]: props.open,
                  // })}
                >
                  {props.open ? <ChevronLeftIcon /> : <MenuIcon />}
                </IconButton>
              </Box>
              {!props.open && (
                <Box mt={1} mb={1} my={1}>
                  <img src={NatJanWhiteLogo} alt="logo" width="35" />
                </Box>
              )}
            </Grid>
          </Grid>
          <Grid item>
            <Box mt={1} mb={1} my={1}>
              <IconButton
                color="inherit"
                onClick={async () => {
                  await dispatch(logOutAction());
                  history.push("/auth/login");
                }}
              >
                <LockOpenIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
        {/* <Typography variant="h6" noWrap className={classes.title}>
            National Janitorial Solutions
          </Typography>
          <IconButton color="inherit" onClick={toggleTheme}>
            {isDarkTheme ? <BrightnessHighIcon /> : <Brightness4Icon />}
          </IconButton> */}
      </Toolbar>
    </AppBar>
    // </Slide>
  );
}
